"use client";
import React from "react";
import { Container, Row, Accordion, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

export default function FleetAppOrion(index){
const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1100);
    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const boxVariantsL = !isMobile
    ? {
        hidden: { opacity: 0, x: index % 2 === 0 ? 350 : -350 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsR = !isMobile
    ? {
        hidden: { opacity: 0, x: index % 2 === 0 ? -350 : 350 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsPop = !isMobile
    ? {
        hidden: { opacity: 0, scale: 0.2 },
        visible: { opacity: 1, scale: 1, transition: { duration: 1 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsY = !isMobile
    ? {
        hidden: { opacity: 0, y: index % 2 === 0 ? -350 : 350 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

    return(<>
    <Row className="pt-5 m-l-0 m-r-0">
            <Col xs={12} md={6} className="p-l-0">
              <img
                src="/Images/Mockups/NauApp/NauApp1.png"
                alt="Products"
                className="img-fluid sticky-top"
              />
            </Col>

            <Col xs={12} md={6} className="motion-container text-left">
              {!isMobile ? (
                <motion.div
                  variants={boxVariantsR}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0 }}
                >
                  <div className="row justify-content-start">
                    <h1
                      className="un-leash-command-heading"
                      style={{ fontSize: "2.5rem" }}
                    >
                      FEATURES & BENEFITS OF THE APP:
                    </h1>
                    <p>
                      The operator receives invaluable information on every
                      operation and activity on the APP based on the acquired
                      measurements, a set of performance parameters which are
                      calculated continuously and available for the fleet to the
                      users to manage their vessels in a more economical and
                      environmentally beneficial way.
                    </p>
                  </div>

                  <Accordion alwaysOpen className=" text-start">
                    <Row className="mt-3 CommonAccordion">
                      <Accordion.Item eventKey="0" className=" mt-2 mb-2">
                        <Accordion.Header>Fleet list</Accordion.Header>
                        <Accordion.Body>
                          <p>
                            All the vessels under your fleet at a glance with
                            their latest reported positions, parameters and
                            statistics.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="4" className=" mt-2 mb-2">
                        <Accordion.Header>Benchmark</Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Benchmark your vessels against their Sea trial as
                            well as Charter party to find the variance.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="7" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Energy efficiency operating index, CO2 and other
                          emissions
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Emissions data readily available along with the EEOI
                            and emissions. The emission of CO2, NOX and SOX is
                            calculated based on combustion process analysis,
                            fuel quality and fuel consumption.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="10" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Fuel Efficiency and speed
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            The speed and power curves with the fuel consumption
                            plotted over the sea trial and shop trial data.
                            Rolling and continuous performance monitoring.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="1" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Under performance Alerts
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Underperformance based on speed, consumption for
                            fuel, lube oils, fresh waters are highlighted for
                            the users.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="5" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Vessel movement information
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Vessel past movement history for viewing trade
                            options, patterns to take a decision for future
                            fixtures.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="8" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Vessel reported data and AIS data overlay
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            The AIS data together with the vessel reported
                            position, weather and other parameters depict the
                            accuracy of the reports from the vessel and also
                            enable the shore office to keep track of any
                            discrepancies.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="11" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Main & Auxiliary Engine efficiency
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Time and power utilization plotted over the fuel
                            efficiency with SFOC provides the helpful data
                            towards efficient and optimum use of the machinery
                            by the vessel staff.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="3" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Information of the planned activities
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            The interface allows the users to view the
                            activities planned and enter on cloud for
                            inspections, repairs, supplies, crew change, etc.
                            planned for the forth coming port.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="6" className=" mt-2 mb-2">
                        <Accordion.Header>Agency Information</Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Ready information for the Owner’s and charterer’s
                            agency information available to directly connect on
                            voice or email. The Company can allow access to
                            agencies and other parties for direct feeds and
                            following the vessels in their region.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="9" className=" mt-2 mb-2">
                        <Accordion.Header>Weather information</Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Wind, waves, currents, temperature, rain and other
                            data is available on the map.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="12" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Waste management overview
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            This is a very important as the system monitors and
                            acts as a warning towards leakage or any
                            abnormalities within the machinery causing over
                            accumulation of bilge water or sludge generation in
                            the tanks.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Row>
                  </Accordion>
                </motion.div>
              ) : (
                <div>
                  <div className="row justify-content-start">
                    <h1
                      className="un-leash-command-heading"
                      style={{ fontSize: "2.5rem" }}
                    >
                      FEATURES & BENEFITS OF THE APP:
                    </h1>
                    <p>
                      The operator receives invaluable information on every
                      operation and activity on the APP based on the acquired
                      measurements, a set of performance parameters which are
                      calculated continuously and available for the fleet to the
                      users to manage their vessels in a more economical and
                      environmentally beneficial way.
                    </p>
                  </div>

                  <Accordion alwaysOpen className=" text-start">
                    <Row className="mt-3 CommonAccordion">
                      <Accordion.Item eventKey="0" className=" mt-2 mb-2">
                        <Accordion.Header>Fleet list</Accordion.Header>
                        <Accordion.Body>
                          <p>
                            All the vessels under your fleet at a glance with
                            their latest reported positions, parameters and
                            statistics.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="4" className=" mt-2 mb-2">
                        <Accordion.Header>Benchmark</Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Benchmark your vessels against their Sea trial as
                            well as Charter party to find the variance.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="7" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Energy efficiency operating index, CO2 and other
                          emissions
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Emissions data readily available along with the EEOI
                            and emissions. The emission of CO2, NOX and SOX is
                            calculated based on combustion process analysis,
                            fuel quality and fuel consumption.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="10" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Fuel Efficiency and speed
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            The speed and power curves with the fuel consumption
                            plotted over the sea trial and shop trial data.
                            Rolling and continuous performance monitoring.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="1" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Under performance Alerts
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Underperformance based on speed, consumption for
                            fuel, lube oils, fresh waters are highlighted for
                            the users.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="5" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Vessel movement information
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Vessel past movement history for viewing trade
                            options, patterns to take a decision for future
                            fixtures.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="8" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Vessel reported data and AIS data overlay
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            The AIS data together with the vessel reported
                            position, weather and other parameters depict the
                            accuracy of the reports from the vessel and also
                            enable the shore office to keep track of any
                            discrepancies.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="11" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Main & Auxiliary Engine efficiency
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Time and power utilization plotted over the fuel
                            efficiency with SFOC provides the helpful data
                            towards efficient and optimum use of the machinery
                            by the vessel staff.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="3" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Information of the planned activities
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            The interface allows the users to view the
                            activities planned and enter on cloud for
                            inspections, repairs, supplies, crew change, etc.
                            planned for the forth coming port.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="6" className=" mt-2 mb-2">
                        <Accordion.Header>Agency Information</Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Ready information for the Owner’s and charterer’s
                            agency information available to directly connect on
                            voice or email. The Company can allow access to
                            agencies and other parties for direct feeds and
                            following the vessels in their region.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="9" className=" mt-2 mb-2">
                        <Accordion.Header>Weather information</Accordion.Header>
                        <Accordion.Body>
                          <p>
                            Wind, waves, currents, temperature, rain and other
                            data is available on the map.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="12" className=" mt-2 mb-2">
                        <Accordion.Header>
                          Waste management overview
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>
                            This is a very important as the system monitors and
                            acts as a warning towards leakage or any
                            abnormalities within the machinery causing over
                            accumulation of bilge water or sludge generation in
                            the tanks.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Row>
                  </Accordion>
                </div>
              )}
            </Col>
          </Row>
    </>)
}